module.exports = __webpack_public_path__ + "img/218.237.f43b4956.png";